import axios from "axios";
import { APIS } from "./utils/api-factory";
import {POST_HEADER,TENANT_HEADER} from '../../../../utils/apiHeaders'


export const saveUpdateCommunityPersonalApi = (userData, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(APIS.SAVE_UPDATE_COMMUNITY_PERSONAL, userData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
       
      });
  };

    export const getAllCommunityForParentCommunity = ( callBack, error) => {
   
    axios
      .get(
        APIS.GET_ALL_COMMUNITY_FOR_PARENT_COMMUNITY )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

    export const getCommunityPersonalApi = (id, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(APIS.GET_COMMUNITY_PERSONAL + id, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const saveUpdateAddressApi = (userData, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    console.log(userData);
    axios
      .post(APIS.SAVE_UPDATE_ADDRESS, userData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

    export const getZipBranchDetailApi = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_BANK_BRANCH_DETAIL + data.code + "&type=" + data.type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

    export const getAddressDetailCommunityApi = (id, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(APIS.GET_ADDRESS_DETAIL_COMMUNITY + id + "&type=", headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.message);
      });
  };
  
    export const SaveUpdateAccountDetailsDealer = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.SAVE_UPDATE_ACCOUNT_DETAILS_DEALER ,data,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };

    export const getCommunityAccountDetailsBycommunityId = (id, callBack, error) => {
   
    axios
      .get(
        APIS.GET_COMMUNITY_ACCOUNT_DETAIL_BY_COMMUNITYID + id )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        // error(e.res.data);
      });
  };


  export const getCommunityApi = (pageNo, noOfRows, data, ParentcommunityId, commType, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  let commCode = data.communityCode !== undefined ? data.communityCode : "";

  axios
    .get(
      APIS.GET_COMMUNITY +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&emailId=" +
      data.emailId +
      "&whoYouAre=" +
      data.whoYouAre +
      "&important=" +
      data.important +
      "&communityCode=" +
      commCode +
      "&mobileNo=" +
      data.mobileNo +
      "&parentCommunityId=" +
      ParentcommunityId +
      "&createdOn=" +
      (data.createdOn != null && data.createdOn != undefined
        ? data.createdOn
        : "")
      + "&communityType=" + commType + "&communityName=" + data.name,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const deleteCommunityApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .delete(APIS.DELETE_COMMUNITY + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getCommunityCountApi = (data, ParentcommunityId, commType, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  
  axios
    .get(
      APIS.GET_COMMUNITY_COUNT +
      data.emailId +
      "&mobileNumber=" +
      data.mobileNo +
      "&communityCode=" +
      data.communityCode +
      "&whoYouAre=" +
      data.whoYouAre +
      "&important=" +
      data.important +
      "&parentCommunityId=" +
      ParentcommunityId +
      "&createdOn=" +
      (data.createdOn != null && data.createdOn != undefined
        ? data.createdOn
        : "")
      + "&communityType=" + commType + "&communityName=" + data.name,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const markImp = (communityId, flag, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.MARK_COMMUNITY_AS_IMP + communityId + "&flag=" + flag,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res);
    });
};

export const downloadcommunityReportByData = (start, end, type, active, callBack, error) => {

  axios.get(APIS.DOWNLOAD_COMMUNITY_REPORT_BY_DATE + start + "&endDate=" + end + "&communityType=" + type + "&active=" + active, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
    .then(res => {
     
      const contentType = res.headers['content-type'] || 'application/vnd.ms-excel';
      console.log('Response content type:', contentType);
      console.log('Response headers:', res.headers);
      let fileExtension = '.xls';
      let mimeType = 'application/vnd.ms-excel';
      
      if (contentType.includes('openxmlformats') || contentType.includes('xlsx')) {
        fileExtension = '.xlsx';
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (contentType.includes('csv')) {
        fileExtension = '.csv';
        mimeType = 'text/csv';
      }
      
      const blob = new Blob([res.data], { type: mimeType });
      
      const downloadUrl = URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${type}_report${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      
      document.body.removeChild(a);
      URL.revokeObjectURL(downloadUrl);
      
      callBack("");
    })
    .catch(e => {
      callBack("")

    })
}

export const getCommunityProfessionalApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_COMMUNITY_PROFESSIONAL + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getDocumentDetailApi = (
  pageNo,
  noOfRows,
  communityId,
  callBack,
  error
) => {

  const lenderId = "";
  const licenseId = "";

  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DOCUMENT_DETAIL +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&lenderId=" +
      lenderId +
      "&licenseId=" +
      licenseId +
      "&communityId=" +
      communityId,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res);
    });
};


export const getBankDetailCommunityApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_BANK_DETAIL_COMMUNITY + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const sendCompleteProfileLink = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.SEND_COMPLETE_PROFILE_LINK + data, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const sendWelcomeMail = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .post(APIS.SEND_WELCOME_MAIL + data, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const sendDocumentLink = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.SEND_DOCUMENT_LINK + data, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};


export const saveUpdateDocumentApiOther = (
  file,
  docName,
  id,
  rowData,
  description,
  replaceOrUpload,
  callBack,
  error
) => {
  const type =
    file.type === "image/png"
      ? "img"
      : file.type === "application/pdf"
        ? "pdf"
        : file.type === "image/jpg"
          ? "img"
          : file.type === "image/jpeg"
            ? "img"
            : "";
  const headerConfig = {
    headers: {},
  };
  let multipartFormData = new FormData();
  multipartFormData.append("docName", docName);
  multipartFormData.append("description", description);
  multipartFormData.append("file", file);
  multipartFormData.append("documentId", id ? id : "");
  multipartFormData.append("type", type);
  multipartFormData.append("fileName", file.name);
  multipartFormData.append(
    "lenderId",
    rowData.lenderId !== undefined ? rowData.lenderId : ""
  );
  multipartFormData.append(
    "licenseId",
    rowData.licenseId ? rowData.licenseId : LICENCE_ID
  );
  multipartFormData.append(
    "userId",
    rowData.userId !== undefined ? rowData.userId : ""
  );
  multipartFormData.append(
    "loanId",
    rowData.loanId !== undefined ? rowData.loanId : ""
  );
  multipartFormData.append(
    "communityId",
    rowData && rowData.communityId
      ? rowData.communityId
      : window.sessionStorage.getItem("communityId")
  );
  multipartFormData.append("replaceOrUpload", replaceOrUpload);

  axios
    .post(APIS.UPLOAD_OTHER_DOCUMENTS, multipartFormData, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const searchDocName = (name, callBack) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_DOC_NAME_SEARCH + name, headerConfig)
    .then(res => {
      callBack(res.data)
    })

}

export const getDealerMappedinAMuAgentBycommId = (commId, isMapped, callBack, error) => {

  axios.get(APIS.GET_MAPPING_DETAILS_FOR_AMU_AGENT + commId + "&mappedOrNot=" + isMapped)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const SaveUpdatedMappedDealer = (data, callBack, error) => {

  axios.post(APIS.SAVE_MAPPED_UNMAPPED_DEALER + data?.parentCommunityId + "&communityId=" + data?.communityId + "&mappedOrNot=" + data?.mappedOrNot)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const getDashboardDataForAMuagentByDate = (data, callBack, error) => {

  axios.get(APIS.GET_DASHBOARD_DATA_FOR_AMU_AGENT_BY_DATE + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getDealerWisAgentPerformanceByDate = (data, callBack, error) => {

  axios.get(APIS.GET_DEALER_WISE_AGENT_PERFORMANCE_BY_DATE + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate + "&filterType=" + data?.filterType)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getLeadageingPerformanceForAmuAgent = (data, callBack, error) => {

  axios.get(APIS.GET_LEAD_AGEING_PERFROMANCE_FOR_AMU_AGENT + data?.communityId + "&filterType=" + data?.filterType + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}
export const getAvgTatGraphforAmuAgent = (data, callBack, error) => {

  axios.get(APIS.GET_AVG_TAT_GRAPH_FOR_AMU_AGENT + data?.communityId + "&filterType=" + data?.filterType + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


// rm dashboard 
export const getCommunityAnalyticsMetricsByDate = (
  start, end,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_COMMUNITY_ANALYTICS_METRICS_BY_DATE + start + "&eDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType, TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getTopPerformingAssetsByDate = (
  start, end,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_TOP_PERFORMING_COMMUNITY_BY_DATE + start + "&eDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getDealerOverviewListByDatestatus = (
  start, end, status, searchBy, page, size,state,city,productType,
  callBack
) => {
  fetch(APIS.GET_DEALER_OVERVIEW_LIST_BY_DATE_STATUS + start + "&eDate=" + end + "&status=" + status + "&searchBy="
    + searchBy + "&pageNo=" + page + "&noOfEntry=" + size + "&state=" + state + "&city=" + city + "&productType=" + productType,TENANT_HEADER
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}
export const getAllstateListDistrictByType = (
type,
  callBack
) => {
  fetch(APIS.GET_ALL_STATE_DISCTIRCT_LIST_BY_TYPE  + type,TENANT_HEADER
  )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}

export const DownloadDealerAgentDashboardList = (
  start,end,state,city,
productType,status,
  callBack
) => {
  fetch(APIS.DOWNLOAD_DEALER_DASHBOARD_ASSIGNMENT_LIST + start + "&eDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType + "&status=" + status,TENANT_HEADER
   )
    
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'Dealer_Data.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}

export const getDealerAgentMapsInfoByData = (
  start,end,state,city,
productType,type,
  callBack
) => {
  fetch(APIS.GET_DEALER_AGENT_MAPS_INFO_BY_DATA + start + "&endDate=" + end + "&state=" + state + "&city=" + city + "&productType=" + productType + "&communityType=" + type ,TENANT_HEADER
   )
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      callBack('')
    })
}